import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router'
import { Container, Grid, Button, IconButton, TextField, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, } from '@material-ui/core'
import { ArrowUpward, ArrowDownward, Search, Clear, Edit, Delete } from "@material-ui/icons"
import { settingAPI } from './../services/SettingService'
import moment from "moment"

const Setting_Type = () => {
    let history = useHistory()
    const token = localStorage.getItem("Token")
    const [data, setData] = useState([])
    const [force, setForce] = useState(0)
    const [searchText, setSearchText] = useState("")
    const [page, setPage] = useState(0);
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [sortBy, setSortBy] = useState("type_name")
    const [sortOrder, setSortOrder] = useState("asc")
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setrowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const DeleteType = (_id) => {
        try {
            let find = data.find((res) => res._id == _id)
            if (!find) throw { message: "ดักไม่พบ ID" }
            Swal.fire({
                title: 'คุณแน่ใจ ?',
                text: `คุณต้องการลบ Type ${find.type_name}`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#56A834',
                cancelButtonColor: '#d33',
                confirmButtonText: 'แน่ใจ',
                cancelButtonText: 'ยังก่อน'
            }).then((result) => {
                if (result.isConfirmed) {
                    settingAPI.DeleteType(token, _id)
                        .then((res) => {
                            if (res.status == 200) {
                                Swal.fire({
                                    icon: 'success',
                                    confirmButtonColor: "#6ab23a",
                                    html: `<span class="colorWhite">${res.message}</span>`,
                                    backdrop: 'transparent',
                                    background: 'rgba(0,0,0,.75)',
                                    customClass: {
                                        icon: 'switchZ'
                                    },
                                    width: '28rem',
                                    timer: 3000
                                }).then(() => {
                                    let dataZ = data.filter((res) => res._id != _id)
                                    setData(dataZ)
                                })
                            }
                            else {
                                Swal.fire({
                                    icon: 'error',
                                    confirmButtonColor: "#f27474",
                                    html: `<span class="colorWhite">${res.message}</span>`,
                                    backdrop: 'transparent',
                                    background: 'rgba(0,0,0,.75)',
                                    customClass: {
                                        icon: 'switch'
                                    },
                                    width: '28rem',
                                    timer: 5000
                                })
                            }
                        })
                        .catch((error) => {
                            Swal.fire({
                                icon: 'error',
                                confirmButtonColor: "#f27474",
                                html: `<span class="colorWhite">${error.message}</span>`,
                                backdrop: 'transparent',
                                background: 'rgba(0,0,0,.75)',
                                customClass: {
                                    icon: 'switch'
                                },
                                width: '28rem',
                                timer: 5000
                            })
                        })
                }

            })
        } catch (error) {
            Swal.fire({
                icon: 'error',
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">${error.message}</span>`,
                backdrop: 'transparent',
                background: 'rgba(0,0,0,.75)',
                customClass: {
                    icon: 'switch'
                },
                width: '28rem',
                timer: 5000
            })
        }
    }

    const StatusShow = (params) => {
        if (params) return "ใช้งาน"
        else return "ไม่ได้ใช้งาน"
    }

    useEffect(() => {
        document.title = `Com7 Merchandise - จัดการ Type`
        settingAPI.GetType(token)
            .then((res) => {
                if (res.status == 200) {
                    setData(res.message)
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "#f27474",
                        html: `<span class="colorWhite">${res.message}</span>`,
                        backdrop: 'transparent',
                        background: 'rgba(0,0,0,.75)',
                        customClass: {
                            icon: 'switch'
                        },
                        width: '28rem',
                        timer: 10000
                    }).then(() => {
                        setForce((old) => old + 1)
                    })
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: 'error',
                    confirmButtonColor: "#f27474",
                    html: `<span class="colorWhite">${error.message}</span>`,
                    backdrop: 'transparent',
                    background: 'rgba(0,0,0,.75)',
                    customClass: {
                        icon: 'switch'
                    },
                    width: '28rem',
                    timer: 10000
                }).then(() => {
                    setForce((old) => old + 1)
                })
            })
        return () => {
            setData([])
        }
    }, [force])
    const filterCondition = (res) => {
        let concat_string = res.type_name.concat(StatusShow(res.status), res.createdAt)
        if (searchText != "") return concat_string.toLowerCase().includes(searchText.toLowerCase())
        else return true
    }
    const changeSortable = (name) => {
        if (name == sortBy) {
            if (sortOrder == "asc") {
                setSortOrder("desc")
            }
            else if (sortOrder == "desc") {
                setSortOrder("")
                setSortBy("")
            }
            else {
                setSortOrder("asc")
            }
        }
        else {
            setSortOrder("asc")
        }
    }
    const sortData = () => {
        let compareFn = null;
        switch (sortBy) {
            case "createdAt":
                compareFn = (i, j) => {
                    if (moment(i[sortBy]).valueOf() < moment(j[sortBy]).valueOf()) {
                        return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                    } else {
                        if (moment(i[sortBy]).valueOf() > moment(j[sortBy]).valueOf()) {
                            return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                        } else {
                            return 0;
                        }
                    }
                }
                break;
            case "status":
                compareFn = (i, j) => {
                    if (StatusShow(i[sortBy]) < StatusShow(j[sortBy])) {
                        return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                    } else {
                        if (StatusShow(i[sortBy]) > StatusShow(j[sortBy])) {
                            return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                        } else {
                            return 0;
                        }
                    }
                };
                break;
            default: compareFn = (i, j) => {
                if (i[sortBy] < j[sortBy]) {
                    return sortOrder == "asc" ? -1 : sortOrder == "desc" ? 1 : 0;
                } else {
                    if (i[sortBy] > j[sortBy]) {
                        return sortOrder == "asc" ? 1 : sortOrder == "desc" ? -1 : 0
                    } else {
                        return 0;
                    }
                }
            }
        }
        return compareFn;
    }
    return (
        <Container>
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <h3><strong>รายการ Type</strong></h3>
                </Grid>
                <Grid item xs={4}>
                    <div style={{ textAlign: 'right' }}>
                        <Button variant="contained"
                            onClick={() => history.push(`/settings/type/create`)}
                            style={{
                                whiteSpace: 'nowrap',
                                border: "2px solid transparent",
                                backgroundColor: "#6ab23a",
                                borderRadius: "5px",
                                color: "white",
                                fontSize: "16px",
                                textDecoration: "none",
                                textTransform: "capitalize",
                            }}>
                            Add Type
                        </Button>
                    </div>
                </Grid>
                <Grid item xs={8}>

                </Grid>
                <Grid item xs={4} style={{ marginTop: '1rem' }}>
                    <TextField
                        style={{ width: '100%' }}
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        placeholder="Search Type…"
                        InputProps={{
                            startAdornment: <Search fontSize="small" />,
                            endAdornment: (
                                <IconButton
                                    title="Clear"
                                    aria-label="Clear"
                                    size="small"
                                    style={{ visibility: searchText != '' ? 'visible' : 'hidden' }}
                                    onClick={() => setSearchText('')}
                                >
                                    <Clear fontSize="small" />
                                </IconButton>
                            ),
                        }}
                    />
                </Grid>
            </Grid>
            <TableContainer component={Paper} style={{ borderRadius: '5px', marginTop: '1.5rem', display: data.length == 0 ? 'none' : 'block', backgroundColor: '#ffffffe6' }}>
                <Table className="ayLmao">
                    <TableHead className="heheXd"
                        style={{
                            height: '50px',
                            position: "sticky",
                            textAlign: 'center'
                        }}>
                        <TableRow >
                            <TableCell>No.</TableCell>
                            <TableCell onClick={() => { setSortBy("type_name"); changeSortable("type_name") }}>Name
                                {sortBy == "type_name" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "type_name" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }} onClick={() => { setSortBy("due_time"); changeSortable("due_time") }}>ระยะเวลาทำงาน (ชม.)
                                {sortBy == "due_time" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "due_time" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                            </TableCell>
                            <TableCell onClick={() => { setSortBy("status"); changeSortable("status") }}>Status
                                {sortBy == "status" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "status" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                            </TableCell>
                            <TableCell onClick={() => { setSortBy("updatedAt"); changeSortable("createdAt") }}>Updated Time
                                {sortBy == "updatedAt" && sortOrder == 'desc' ? <ArrowUpward style={{ fontSize: '14px' }} /> : sortBy == "updatedAt" && sortOrder == 'asc' && <ArrowDownward style={{ fontSize: '14px' }} />}
                            </TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ textAlign: 'center' }}>
                        {data.filter(filterCondition).sort(sortData()).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((res, i) => (
                            <TableRow key={i}>
                                <TableCell>{((page - 1) * rowsPerPage + rowsPerPage + 1) + i}</TableCell>
                                <TableCell>{res.type_name}</TableCell>
                                <TableCell style={{ textAlign: 'center' }}>{res.due_time ? res.due_time / 3600 : "-"}</TableCell>
                                <TableCell>{StatusShow(res.status)}</TableCell>

                                <TableCell>{moment(res.updatedAt).utcOffset('+0700').format("DD MMM YYYY HH:mm:ss")}</TableCell>
                                <TableCell><Button
                                    type="submit"
                                    variant="contained"
                                    style={{
                                        border: "2px solid transparent",
                                        backgroundColor: "#6ab23a",
                                        borderRadius: "10px",
                                        color: "white",
                                        fontSize: "14px",
                                        textDecoration: "none",
                                        textTransform: "capitalize",
                                    }}
                                    onClick={() => history.push(`/settings/type/edit/${res._id}`)}
                                >
                                    Edit <Edit fontSize={"small"} />
                                </Button>{" "}
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        style={{
                                            border: "2px solid transparent",
                                            backgroundColor: "#f27474",
                                            borderRadius: "10px",
                                            color: "white",
                                            fontSize: "14px",
                                            textDecoration: "none",
                                            textTransform: "capitalize",
                                        }}
                                        onClick={() => DeleteType(res._id)}
                                    >
                                        Delete <Delete fontSize={"small"} />
                                    </Button></TableCell>
                            </TableRow>
                        ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            {data.length > 10 && <TablePagination
                rowsPerPageOptions={[
                    5,
                    10,
                    25,
                    { label: 'All', value: data.filter(filterCondition).length },
                ].filter((res) => res != data.filter(filterCondition).length)}
                rowsPerPage={rowsPerPage}
                page={page}
                component="div"
                count={data.filter(filterCondition).length}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />}
        </Container >
    )
}

export default Setting_Type